type ToInitialsProps = {
	firstName?: string | null;
	lastName?: string | null;
};

export const toInitials = ({ firstName, lastName }: ToInitialsProps) =>
	`${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
